module.exports = __webpack_public_path__ + "img/medalha-inovacao-sustentatilidade.f48cd527.jpeg";